import { createAction } from '@reduxjs/toolkit';
export var RESET_TO_INITIAL = 'RESET_TO_INITIAL';
export var resetToInitial = createAction(RESET_TO_INITIAL);
export var LOG_OUT = 'LOG_OUT';
export var logOut = createAction(LOG_OUT);
